import * as React from "react";
import { useLanguage } from "./Language";
import { BranchLimit, useBranchLimits } from "./BranchLimits";
import { useForm, FormProvider } from "react-hook-form";
import { CheckboxGroup } from "@tlc/forms/CheckboxGroup";
import { FormDialog } from "@tlc/ui/dialog/FormDialog";
export interface LocationSummaryProps {
  branchLimits: BranchLimit[];
  /**
   * if set, BranchLimit.selected is ignored
   */
  selected: readonly BranchLimit["identifier"][];
  prefixText?: string;
}
export const LocationSummary: React.FC<LocationSummaryProps> = ({
  branchLimits,
  selected,
  prefixText,
}) => {
  const { translate } = useLanguage();
  const selectedBranches = (branchLimits || [])
    .filter((branch) => !branch.hidden && branch.displayInBranchLimits)
    .filter((branch) => selected.includes(branch.identifier));

  return (
    <React.Fragment>
      {selectedBranches.length === 0
        ? `${prefixText ? `${prefixText} ` : ""}${translate("allLocations")}`
        : selectedBranches.length === 1
        ? `${prefixText ? `${prefixText} ` : ""}${
            selectedBranches[0].displayName
          }`
        : `${prefixText ? `${prefixText} ` : ""}${
            selectedBranches.length
          } ${translate("selectedLocations")}`}
    </React.Fragment>
  );
};

export interface LocationDialogProps {
  open: boolean;
  onSubmit: (value: readonly string[]) => void;
  onClose?: () => void;
}
export const LocationDialog: React.FC<LocationDialogProps> = ({
  open,
  onSubmit,
  onClose,
}) => {
  const { selectedBranchIds, branchLimits } = useBranchLimits();
  console.log("rendering Location Dialog", open);
  console.log(branchLimits);
  const branches = (branchLimits || []).filter(
    (branch) => !branch.hidden && branch.displayInBranchLimits,
  );

  const form = useForm<{ locations: string[] }>({
    defaultValues: {
      locations: [...selectedBranchIds],
    },
  });

  React.useEffect(() => {
    form.reset({ locations: [...selectedBranchIds] });
  }, [selectedBranchIds, form]);

  const [isOpen, setIsOpen] = React.useState<boolean>(open);

  React.useEffect(() => {
    setIsOpen(open);
  }, [open]);
  console.log("isOpen", isOpen);
  const { translate } = useLanguage();
  const handleClose = () => {
    setIsOpen(false);
    form.reset({ locations: [...selectedBranchIds] });
    if (onClose) {
      onClose();
    }
  };

  const handleSubmit = form.handleSubmit((data) => {
    setIsOpen(false);
    onSubmit(data.locations);
  });

  const formId = "location-dialog-form";
  const headlineId = `${formId}-headline`;

  return (
    <FormDialog
      id="select-location-dialog"
      open={isOpen}
      headline={translate("selectLocations")}
      confirmButtonText={
        <LocationSummary
          prefixText={translate("search")}
          branchLimits={branchLimits}
          selected={form.watch("locations")}
        ></LocationSummary>
      }
      formId={formId}
      onClose={handleClose}
    >
      <FormProvider {...form}>
        <form onSubmit={handleSubmit} id={formId} noValidate>
          <CheckboxGroup
            id="location-selection"
            name="locations"
            aria-labelledby={headlineId}
            selectAll
            selectAllLabel={translate("selectedLocations")}
            options={branches.map((branch) => ({
              label: branch.displayName,
              value: branch.identifier,
            }))}
            fullWidth
          />
        </form>
      </FormProvider>
    </FormDialog>
  );
};
